import { render } from "./MetaTag.vue?vue&type=template&id=36b1231f"
import script from "./MetaTag.vue?vue&type=script&lang=js"
export * from "./MetaTag.vue?vue&type=script&lang=js"

import exportComponent from "/Users/widyaputra/Documents/ybpm/sch-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__